import { userConstants } from '../_constants';

export function registration(state = {}, action) {
  switch (action.type) {
    case userConstants.REGISTER_REQUEST:
      return { loading: true };
    case userConstants.REGISTER_SUCCESS:
      return {reload: true};
    case userConstants.REGISTER_FAILURE:
      return {};
    default:
      return state
  }
}